import { useState, useEffect } from 'react';

import { FormikSelectOption } from '@models/common/FormikSelectOption';
import { SalesTaxViewModel } from '@models/SalesTax';
import { SalesTaxService } from '@services/SalesTax';

const stripTime = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const useSalesTaxEffectiveRates = () => {
  const [effectiveDate, setEffectiveDate] = useState<Date>(
    stripTime(new Date())
  );
  const [salesTaxes, setSalesTaxes] = useState<FormikSelectOption[]>([]);
  const [salesTaxEffectiveRates, setSalesTaxEffectiveRates] = useState<
    SalesTaxViewModel[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string[] | undefined>([]);

  const loadData = async (effectiveDate: Date) => {
    setIsLoading(true);
    const result = await SalesTaxService.getSalesTaxEffectiveRates(
      effectiveDate
    );

    if ('data' in result) {
      const salesTaxSelectOptions = [{ value: '0', text: '' }].concat(
        result.data.map((row) => ({
          value: row.id.toString(),
          text: `${row.abbreviation}`,
        }))
      );
      setSalesTaxes(salesTaxSelectOptions);
      setSalesTaxEffectiveRates(result.data);
      setIsLoading(false);
      setIsSuccess(true);
      console.log('Success: Fetched the record.');
    } else {
      console.error('Error: Failed to get record.', result.errorMessages);
      setIsSuccess(false);
      setErrorMessages(result.errorMessages);
    }
  };

  const updateEffectiveDate = (date: Date) => {
    const dateWithoutTime = stripTime(date);
    setEffectiveDate(dateWithoutTime);
  };

  useEffect(() => {
    loadData(effectiveDate);
  }, [effectiveDate]);

  return {
    salesTaxes,
    salesTaxEffectiveRates,
    isLoading,
    isSuccess,
    errorMessages,
    loadData: updateEffectiveDate,
  };
};
